import 'element/css/button.scss'

import Button from './component'

export default Button
